export const mapTypeToTranslation = (type, formatMessage) => {
  const mapTypeUrl = {
    link: 'Activate Service',
    file: 'Download plugin',
    info: 'More info',
  };

  return mapTypeUrl[type] ? formatMessage({ id: mapTypeUrl[type] }) : null;
};
